import { Calendar, AlertCircle, Loader2 } from 'lucide-react'
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui'
import { cn, formatDate, getDeadlineColor } from '@/lib/utils'
import { useWeekDeadlines } from '@/hooks'

export function DeadlineWidget() {
  const { data: deadlines, isLoading, isError } = useWeekDeadlines()

  return (
    <Card>
      <CardHeader className="pb-3">
        <CardTitle className="text-base font-semibold flex items-center gap-2">
          <Calendar className="h-4 w-4" />
          Upcoming Statutory Deadlines
        </CardTitle>
      </CardHeader>
      <CardContent>
        {isLoading ? (
          <div className="flex items-center justify-center py-8">
            <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
          </div>
        ) : isError ? (
          <div className="flex items-center justify-center py-8 text-muted-foreground">
            <AlertCircle className="h-5 w-5 mr-2" />
            Failed to load deadlines
          </div>
        ) : deadlines?.length === 0 ? (
          <div className="text-center py-8">
            <Calendar className="h-10 w-10 text-muted-foreground/50 mx-auto mb-3" />
            <p className="text-muted-foreground">No deadlines in the next 7 days</p>
          </div>
        ) : (
          <div className="space-y-3">
            {deadlines?.map((deadline, index) => (
              <div
                key={`${deadline.return_type}-${deadline.period}-${index}`}
                className="flex items-center justify-between p-3 rounded-lg bg-muted/20 border border-border/30 hover:bg-muted/30 transition-all"
              >
                <div className="space-y-1">
                  <p className="font-medium text-sm">{deadline.name}</p>
                  <p className="text-xs text-muted-foreground">
                    {deadline.return_type} · {deadline.period}
                  </p>
                </div>
                <div className="text-right">
                  <p className={cn('text-sm font-medium font-mono tabular-nums', getDeadlineColor(deadline.days_left))}>
                    {deadline.days_left === 0
                      ? 'Due Today'
                      : deadline.days_left === 1
                      ? 'Tomorrow'
                      : `${deadline.days_left} days`}
                  </p>
                  <p className="text-xs text-muted-foreground">
                    {formatDate(deadline.due_date)}
                  </p>
                </div>
              </div>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  )
}
